const redirectToShoyo = async (personalEmail, session) => {
    const { email, shoyo } = session;
    const { shoyoUrlRedirect } = shoyo;

    window.open(`${shoyoUrlRedirect}/view-sbox?user=${email}&client=${personalEmail}`);
};

export default redirectToShoyo;
